module.exports = __webpack_public_path__ + "img/bayer-video-interativo-representante-digital.323b3e65.jpg";